// extracted by mini-css-extract-plugin
module.exports = {"topContainer":"style_topContainer__iPYBp","title":"style_title__Gx2mM","rightArrow":"style_rightArrow__60csL","boxContainer":"style_boxContainer__eW58b","box":"style_box__PS48l"};